var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slideshow-page"},[(_vm.loaded)?_c('Slideshow',{attrs:{"slides":_vm.slides || _vm.wpSlides,"settings":_vm.slideshowSettings,"hasPopup":true}}):_vm._e(),_c('PageDescription',{attrs:{"post":_vm.post}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }